import React from "react";
import { money } from "@/lib/financeApi";
import { day } from "@/components/nds/windows/finance/flow/TxnCard";

export const BUCKETS = [["checking", "Cash in Hand"], ["savings", "Savings"], ["loan", "Line of Credit"], ["escrow", "Rent"], ["program_fee", "PACT Fee"]];
const NAME = Object.fromEntries(BUCKETS);
const COLS = [["rent_paid", "Rent paid"], ["cm_paid", "PACT Fee paid"], ["loc_owed", "LOC owed"], ["loc_paid", "LOC paid"], ["loc_balance", "LOC balance"]];

/** What a Fix-this-week bucket move would change, before it's saved. */
export function BucketPreview({ p }) {
  return (
    <div data-testid="flow-fixweek-preview" className="space-y-2 border border-nex-gold/30 rounded-sm p-2">
      <div className="text-nex-silver">Preview · nothing saved yet</div>
      <div className="space-y-0.5">{Object.entries(p.balances).map(([b, v]) => (
        <div key={b} data-testid={`flow-fixweek-preview-bucket-${b}`}>{NAME[b]} <span className="font-mono">{money(v.before)} → {money(v.after)}</span></div>))}
        <div data-testid="flow-fixweek-preview-loc">Line of Credit total <span className="font-mono">{money(p.line_of_credit.before)} → {money(p.line_of_credit.after)}</span></div></div>
      {p.changed_weeks.length ? <div className="max-h-48 overflow-y-auto space-y-1">{p.changed_weeks.map((w) => (
        <div key={w} data-testid={`flow-fixweek-preview-week-${w}`} className="border-t border-white/5 pt-1">
          <div className="text-nex-silver">Week ending {day(w)}</div>
          <div className="text-nex-muted">{COLS.filter(([k]) => p.before[w]?.[k] !== p.after[w]?.[k]).map(([k, l]) => `${l} ${money(p.before[w]?.[k] || 0)} → ${money(p.after[w]?.[k] || 0)}`).join(" · ") || "Running totals only"}</div>
        </div>))}</div> : <div className="text-nex-muted">No week numbers change.</div>}
      <div className="text-nex-muted">Earlier weeks are not changed.</div>
    </div>
  );
}
